import getIntl from 'Helpers/intl'
import { logAppError, logAppInfo } from 'Helpers/logger'
import {
  createInactiveSchedule,
  deleteRecipients,
  evaluateSendingBestPlanningTime,
  fetchSenderInfo,
  getAccountSendingLimits,
  getBestPlanningDataAvailable,
  getDynamicContents,
  getDynamicFields,
  getFilters,
  getLastConfigurationsByInvio,
  getNoDisturbConfig,
  getQueueConfiguration,
  getRecipientTestsDefault,
  getSendingSegmentation,
  getSmartPlanningSuggestedDate,
  getUserColumns,
  notifyQueueing,
  processQueueingConfiguration,
  putBeListSenderInfo,
  removeNoDisturbConfig,
  resetSendingQueue,
  retryCheckQueue,
  saveQueueingConfiguration,
  scheduleNow,
  searchForRecipients,
  setNoDisturbConfig,
  setSendingImmediate,
  setSendingScheduled,
  simulatePreview,
  simulateSending,
  updateNoDisturbConfig,
  updateSenderInEmailQueue,
  updateUserColumns
} from 'Pages/EmailSendingWizard/recoil/actions/actions'
import {
  abitudiniApertureState,
  pageState,
  smartPlanningState
} from 'Pages/EmailSendingWizard/recoil/state/page'
import {
  isScheduledSendingState,
  lastSendingState,
  senderInfoState
} from 'Pages/EmailSendingWizard/recoil/state/senderInfo'

import {
  BEQUEUE_CONFIG_STATE_CANCELLED,
  BEQUEUE_CONFIG_STATE_COMPLETED,
  BEQUEUE_CONFIG_STATE_DISCARDED,
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RETRIED,
  BEQUEUE_CONFIG_STATE_RUNNING,
  BEQUEUE_CONFIG_STATE_TOEXECUTE,
  BEQUEUE_CONFIG_STATE_UPDATING
} from 'Api/beQueueApi'
import { TRUSTED_SENDER_STATUS_NOT_CONFIRMED } from 'Api/beSendGoApi'
import { getTimeObj } from 'Helpers/dates'
import { storeGet } from 'Helpers/localStorage'
import { pendoTrack } from 'Helpers/pendoTracking'
import { messageDetailsState } from 'Hooks/useMessageDetails/state'
import fetchStatus from 'Hooks/useTrustedEmailSender/fetchStatus'
import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_FEATURES,
  STORE_KEY_LIST
} from 'mailup-react-helpers'
import {
  PROGRESSBAR_VARIANT_DEFAULT,
  PROGRESSBAR_VARIANT_ERROR,
  PROGRESSBAR_VARIANT_SUCCESS,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_WARNING,
  toastShow
} from 'mailup-web-components'
import moment from 'moment-timezone'
import {
  progressState,
  SENDING_METHOD_TYPE_FREQUENCY
} from 'Pages/EmailSendingWizard/recoil/state/queue'
import {
  dynamicFieldsState,
  recipientsDataTablePreviewState,
  searchCriteriaOptionsState,
  searchCriteriaState,
  sendingPreviewState,
  visibleColumnsState
} from 'Pages/EmailSendingWizard/recoil/state/searchCriteria'
import { fasciaDiNonDisturboState } from '../state/fasciaDiNonDisturbo'
import {
  modalColumnsManagementState,
  modalDeleteState,
  modalSchedulingState,
  modalSendingSegmentationState
} from '../state/modals'

import { MODE_SMART } from 'Constants/index'

export const cleanupCallback = ({ reset }) => () => {
  reset(pageState)
  reset(abitudiniApertureState)
  reset(fasciaDiNonDisturboState)
  reset(smartPlanningState)
  reset(isScheduledSendingState)
}

export const initFasciaDiNonDisturboCallback = ({
  set,
  reset,
  snapshot
}) => async () => {
  try {
    set(fasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: false
    }))

    const { sendingOrScheduleId } = await snapshot.getPromise(senderInfoState)

    const resp = await getNoDisturbConfig(sendingOrScheduleId)

    set(fasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: resp && resp.NoDisturbHours.length > 0,
      isFirstConfiguration: !resp,
      Start: resp ? getTimeObj(resp.NoDisturbHours[0].Start, 'T') : prev.Start,
      End: resp ? getTimeObj(resp.NoDisturbHours[0].End, 'T') : prev.End
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'getLastConfigurationsByInvioCallback',
      Message: 'getLastConfigurationsByInvioCallback'
    })

    set(fasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: false
    }))
  }
  return true
}

export const setFasciaDiNonDisturboCallback = ({
  set,
  reset,
  snapshot
}) => async source => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))
  try {
    const {
      Start,
      End,
      enable,
      isFirstConfiguration
    } = await snapshot.getPromise(fasciaDiNonDisturboState)
    reset(fasciaDiNonDisturboState)
    const { sendingOrScheduleId } = await snapshot.getPromise(senderInfoState)
    const { idMessage } = await snapshot.getPromise(pageState)
    if (!enable && !isFirstConfiguration) {
      await removeNoDisturbConfig(sendingOrScheduleId)
      return true
    } else if (enable) {
      const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

      const value = {
        TimeZone: TimeZoneCode,
        NoDisturbHours: [
          {
            Start:
              '1900-01-01T' +
              (Start.hours < 10 ? '0' + Start.hours : Start.hours) +
              ':' +
              (Start.minutes < 10 ? '0' + Start.minutes : Start.minutes) +
              ':00.000Z',
            End:
              '1900-01-01T' +
              (End.hours < 10 ? '0' + End.hours : End.hours) +
              ':' +
              (End.minutes < 10 ? '0' + End.minutes : End.minutes) +
              ':00.000Z'
          }
        ]
      }
      if (isFirstConfiguration) {
        await setNoDisturbConfig(sendingOrScheduleId, value)
      } else {
        await updateNoDisturbConfig(sendingOrScheduleId, value)
      }

      if (source === 'standBy') {
        pendoTrack(
          'evento wizard invio: wizard invio - attivazione FdND su Decidi più tardi',
          {
            idMessage: idMessage
          }
        )
      } else if (source === 'SendNow') {
        pendoTrack(
          'evento wizard invio: wizard invio - attivazione FdND su Invia Subito',
          {
            idMessage: idMessage
          }
        )
      } else if (source === 'scheduled') {
        pendoTrack(
          'evento wizard invio: wizard invio - attivazione FdND su Modale di Schedulazione',
          {
            idMessage: idMessage
          }
        )
      }
    }

    set(pageState, prev => ({
      ...prev,
      loading: false
    }))
    return true
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'getLastConfigurationsByInvioCallback',
      Message: 'getLastConfigurationsByInvioCallback'
    })

    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      loading: false
    }))
    return false
  }
}

export const initSendingWizardCallback = ({ set }) => async (
  idMessage,
  { onQueueRetried, onTrialRecipientLimit }
) => {
  set(pageState, prev => ({
    ...prev,
    loading: true,
    loaded: false,
    error: undefined,
    wizardStep: 1
  }))
  try {
    const [
      { TotalSend, TotalQueued, SendLimit, TrialRecepientLimit },
      senderInfo,
      testDefault,
      dynamicFields,
      userColumns
    ] = await Promise.all([
      getAccountSendingLimits(),
      fetchSenderInfo(idMessage),
      getRecipientTestsDefault(),
      getDynamicFields(),
      getUserColumns()
    ])

    senderInfo.savedAsDefault = senderInfo.senderEmail
    senderInfo.oldSenderEmail = senderInfo.senderEmail
    senderInfo.oldSenderName = senderInfo.senderName
    if (senderInfo.senderEmail === null || senderInfo.senderEmail === '') {
      senderInfo.senderIsDeleted = true
      senderInfo.waitForVerified = true
      senderInfo.savedAsDefault = undefined
    } else {
      const res = await fetchStatus(senderInfo.senderEmail)
      if (res.Status === TRUSTED_SENDER_STATUS_NOT_CONFIRMED) {
        senderInfo.senderIsDeleted = true
        senderInfo.waitForVerified = true
        senderInfo.savedAsDefault = undefined
      }
    }
    set(senderInfoState, senderInfo)

    set(dynamicFieldsState, dynamicFields)

    const safeUserColumns = userColumns.filter(column => {
      const dynamicFieldMatch = column.match(/Field(\d+)/)

      return dynamicFieldMatch
        ? dynamicFields.find(({ Id }) => Id === parseInt(dynamicFieldMatch[1]))
        : true
    })

    set(visibleColumnsState, safeUserColumns)

    if (senderInfo.idAsyncQueueConfig) {
      if (
        [BEQUEUE_CONFIG_STATE_FAILED, BEQUEUE_CONFIG_STATE_RUNNING].includes(
          senderInfo.queueStatus
        )
      ) {
        set(pageState, prev => ({ ...prev, wizardStep: 3 }))
      } else if (senderInfo.queueStatus === BEQUEUE_CONFIG_STATE_RETRIED) {
        onQueueRetried()
      } else {
        set(pageState, prev => ({ ...prev, showSegmentationMessage: true }))
      }
    }

    const remainingSendings = SendLimit - TotalSend - TotalQueued

    if (TrialRecepientLimit > 0 && remainingSendings <= 1) {
      onTrialRecipientLimit(remainingSendings)
    }

    set(pageState, prev => ({
      ...prev,
      totalSend: TotalSend,
      totalQueued: TotalQueued,
      sendLimit: SendLimit,
      trialRecipientLimit: TrialRecepientLimit,
      remainingSendings: remainingSendings,
      idTestDefault: testDefault && testDefault.Id ? testDefault.Id : undefined,
      idMessage
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'initSendingWizardCallback',
      Message: 'Errore in ottieni i dettagli del messaggio',
      Data: JSON.stringify({ idMessage })
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loaded: true, loading: false }))
}

export const changeWizardStepCallback = ({ set }) => nextStep => {
  set(pageState, prev => ({ ...prev, wizardStep: nextStep }))
}

export const eraseSelectedSegmentCallback = ({
  set,
  reset,
  snapshot
}) => async () => {
  try {
    set(pageState, prev => ({ ...prev, loading: true, loaded: true }))

    const { queued, lastSendingId } = await snapshot.getPromise(senderInfoState)

    const res = await resetSendingQueue(lastSendingId)
    if (res) {
      const {
        includeGroups,
        excludeGroups,
        selectedFilters,
        typeAppliedFilters
      } = await snapshot.getPromise(searchCriteriaState)

      const resSimulatePreview = await simulatePreview(
        true,
        lastSendingId,
        includeGroups,
        excludeGroups,
        selectedFilters,
        typeAppliedFilters
      )

      const diff = resSimulatePreview.ToBeQueued - (queued || 0)

      set(sendingPreviewState, prev => ({
        ...prev,
        toBeQueued: resSimulatePreview.ToBeQueued,
        diff,
        oldIncludeGroups: includeGroups,
        oldExcludeGroups: excludeGroups,
        oldSelectedFilters: selectedFilters
      }))

      set(searchCriteriaState, prev => ({
        ...prev,
        includeGroups: [],
        excludeGroups: [],
        selectedFilters: [],
        typeAppliedFilters: 'All'
      }))

      set(pageState, prev => ({ ...prev, showSegmentationMessage: false }))
    } else {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR
      )
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'getLastConfigurationsByInvioCallback',
      Message: 'getLastConfigurationsByInvioCallback'
    })

    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false, loaded: true }))
}

export const getLastConfigurationsByInvioCallback = ({
  set
}) => async idSend => {
  try {
    const conf = await getLastConfigurationsByInvio(idSend)
    set(lastSendingState, conf)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'eraseSelectedSegmentCallback',
      Message: 'eraseSelectedSegmentCallback'
    })
  }
}

export const sendingSegmentationCallback = ({ set }) => async idSending => {
  set(modalSendingSegmentationState, prev => ({
    ...prev,
    show: true,
    loading: true
  }))
  try {
    const {
      groups,
      excludedGroups,
      filters,
      idMessage,
      stopped,
      ...rest
    } = await getSendingSegmentation(idSending)

    const section = groups.length
      ? 'groups'
      : excludedGroups.length
      ? 'excludedGroups'
      : filters.length
      ? 'filters'
      : 'undefined'

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      loading: false,
      groups,
      excludedGroups,
      filters,
      section,
      idSending,
      idMessage,
      ...rest
    }))

    pendoTrack('Sending - Modal segmentation - impression', {
      IdMessage: idMessage,
      SegemtationApplied: section ? 'True' : 'False',
      IsStopped: stopped ? 'True' : 'False'
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'ScheduledSendings',
      Method: 'sendingSegmentationCallback',
      Message: 'Errore in apertura modale di segmentazione',
      Data: JSON.stringify({ idSending })
    })

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      loading: false,
      idSending,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const sendingSegmentationSimulateCallback = ({
  set,
  snapshot
}) => async () => {
  const {
    idMessage,
    idSending,
    groups,
    excludedGroups,
    filters,
    queued
  } = await snapshot.getPromise(modalSendingSegmentationState)

  set(modalSendingSegmentationState, prev => ({
    ...prev,
    simulationLoading: true
  }))

  try {
    const { ToBeQueued } = await simulateSending(
      idSending,
      groups,
      excludedGroups,
      filters
    )

    const simulationDiff = ToBeQueued - queued

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      simulationResult: ToBeQueued,
      simulationDiff
    }))

    pendoTrack('Sending - Modal segmentation - result recipients', {
      IdMessage: idMessage,
      IsTheSame: simulationDiff === 0 ? 'True' : 'False',
      Result: simulationDiff
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'ScheduledSendings',
      Method: 'sendingSegmentationSimulateCallback',
      Message: 'Errore in simulazione da modale di segmentazione',
      Data: JSON.stringify({ idSending })
    })

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const fetchDynamicFields = ({ set }) => async () => {
  try {
    const dynamicFields = await getDynamicFields()

    const dynamicOptions = dynamicFields.map(e => {
      return {
        value: e.Id,
        label: `${e.Id} - ${e.Description}`
      }
    })

    set(pageState, prev => ({
      ...prev,
      dynamicOptions
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'fetchDynamicFields',
      Message: 'Errore in ottieni i campi dinamici'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const putBeListSenderInfoCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({ ...prev, loading: true }))
  const { senderEmail, senderName, replyToEmail } = await snapshot.getPromise(
    senderInfoState
  )
  const data = {
    SenderName: senderName,
    SenderEmail: senderEmail,
    SenderReplyTo: replyToEmail
  }
  try {
    const { Result } = await putBeListSenderInfo(data)
    if (Result) {
      set(senderInfoState, prev => ({
        ...prev,
        savedAsDefault: senderEmail
      }))
      toastShow(
        getIntl().formatMessage({ id: 'Load.Alerts.SuccessUpdate' }),
        TOAST_VARIANT_SUCCESS,
        'saveSenderInfoSuccess'
      )
    } else {
      toastShow(
        getIntl().formatMessage({ id: 'Load.EmailCheckUp.ToastSaveError' }),
        TOAST_VARIANT_WARNING,
        'saveSenderInfoError'
      )
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'saveSenderFields',
      Message: 'Errore in ottieni i campi dinamici'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
    toastShow(
      getIntl().formatMessage({ id: 'Load.EmailCheckUp.ToastSaveError' }),
      TOAST_VARIANT_WARNING,
      'saveSenderInfoError'
    )
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const initSearchCriteriaCallback = ({ set, snapshot }) => async () => {
  set(searchCriteriaState, prev => ({ ...prev, loading: true }))

  try {
    const filters = await getFilters()

    set(searchCriteriaOptionsState, prev => ({
      ...prev,
      filters
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'SendingWizard',
      Method: 'searchCriteriaCallback',
      Message: 'Errore in ottieni criteri di ricerca'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(searchCriteriaState, prev => ({ ...prev, loading: false, loaded: true }))
}

export const modalColumnsManagementConfirmCallback = ({
  set
}) => async value => {
  try {
    await updateUserColumns({ Columns: value })
  } catch (error) {
    logAppError({
      appError: error
    })
    toastShow(
      getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      TOAST_VARIANT_ERROR
    )
  }
  set(visibleColumnsState, value)
  set(modalColumnsManagementState, { show: false })
}

async function doRecipientsDataCallback(set, snapshot) {
  const searchCriteria = await snapshot.getPromise(searchCriteriaState)
  const recipientsDataTable = await snapshot.getPromise(
    recipientsDataTablePreviewState
  )
  set(recipientsDataTablePreviewState, prev => ({
    ...prev,
    loading: true,
    loaded: false
  }))
  try {
    const res = await searchForRecipients(searchCriteria, recipientsDataTable)
    set(recipientsDataTablePreviewState, prev => ({
      ...prev,
      loading: false,
      loaded: true,
      firstChange: false,
      items: res.Items
    }))
  } catch (error) {
    logAppError({
      appError: error
    })
    searchCriteria.selectedFilters.length > 0 &&
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.GenericErrorApplyFiltersNew'
        }),
        TOAST_VARIANT_ERROR
      )
  }
  set(recipientsDataTablePreviewState, prev => ({
    ...prev,
    loading: false,
    loaded: true
  }))
}

export const setTestGroupCallback = ({ set, snapshot }) => async () => {
  const { includeGroups } = await snapshot.getPromise(searchCriteriaState)
  const { idTestDefault } = await snapshot.getPromise(pageState)

  if (includeGroups.length === 0) {
    set(searchCriteriaState, prev => ({
      ...prev,
      includeGroups: [idTestDefault]
    }))
  }
}

export const sendingPreviewCallback = ({ snapshot, set }) => async () => {
  await doSimulatePreviewFetch(set, snapshot)
}

export const searchRecipientsDataCallback = ({ snapshot, set }) => async () => {
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))
  await doRecipientsDataCallback(set, snapshot)
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))
}

export const searchRecipientsAndSendingPreviewDataCallback = ({
  set,
  snapshot
}) => async () => {
  set(sendingPreviewState, prev => ({
    ...prev,
    previewLoading: true,
    showLoading: true
  }))
  try {
    await doRecipientsDataCallback(set, snapshot)
    await doSimulatePreviewFetch(set, snapshot)
  } catch (error) {
    logAppError({
      appError: error
    })
  }
  set(sendingPreviewState, prev => ({
    ...prev,
    previewLoading: false
  }))
}

async function doSimulatePreviewFetch(set, snapshot) {
  set(sendingPreviewState, prev => ({
    ...prev,
    loading: true,
    loaded: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    excludedGroups: [],
    diff: undefined,
    showLoading: true
  }))

  const { queued, lastSendingId } = await snapshot.getPromise(senderInfoState)

  const {
    includeGroups,
    excludeGroups,
    selectedFilters,
    typeAppliedFilters
  } = await snapshot.getPromise(searchCriteriaState)
  try {
    const [{ ToBeQueued }, { ToBeQueued: TotalItems }] = await Promise.all([
      simulatePreview(
        true,
        lastSendingId || 0,
        includeGroups,
        excludeGroups,
        selectedFilters,
        typeAppliedFilters
      ),
      simulatePreview(false, lastSendingId || 0)
    ])

    const diff = ToBeQueued - (queued || 0)

    set(sendingPreviewState, prev => ({
      ...prev,
      toBeQueued: ToBeQueued,
      diff,
      totalRecipients: TotalItems,
      oldIncludeGroups: includeGroups,
      oldExcludeGroups: excludeGroups,
      oldSelectedFilters: selectedFilters
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'sendingPreviewState',
      Method: 'sendingPreviewState',
      Message: 'Errore in simulazione da step wizard'
    })

    set(sendingPreviewState, prev => ({
      ...prev,
      loading: false,
      loaded: true,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false,
    loading: false,
    loaded: true
  }))
}

export const goToStep2Callback = ({ set, snapshot }) => async () => {
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))

  try {
    const {
      senderEmail,
      senderName,
      oldSenderName,
      oldSenderEmail
    } = await snapshot.getPromise(senderInfoState)
    const { showSegmentationMessage } = await snapshot.getPromise(pageState)
    const { lastSendingId } = await snapshot.getPromise(senderInfoState)

    if (
      showSegmentationMessage &&
      (senderEmail !== oldSenderEmail || senderName !== oldSenderName)
    ) {
      await updateSenderInEmailQueue(
        lastSendingId,
        senderName,
        senderEmail,
        oldSenderName,
        oldSenderEmail
      )
    }

    set(pageState, prev => ({
      ...prev,
      wizardStep: prev.wizardStep + 1,
      wizardStep1Done: true
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'startQueueing',
      Message: "Errore durante l'accodamento dei messaggi"
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailSendingWizard.labelErrorMaster'
      }),
      TOAST_VARIANT_ERROR,
      'startQueueInfoFailed',
      false,
      true
    )
  }

  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))
}

export const startQueueAndGoToStep3Callback = ({
  set,
  snapshot
}) => async () => {
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))
  const {
    includeGroups,
    excludeGroups,
    selectedFilters,
    typeAppliedFilters
  } = await snapshot.getPromise(searchCriteriaState)
  const {
    senderEmail,
    senderName,
    replyToEmail,
    customEmailValue,
    customNameValue,
    lastSendingId
  } = await snapshot.getPromise(senderInfoState)
  const { idMessage } = await snapshot.getPromise(pageState)
  let inactiveScheduleResponse

  try {
    await notifyQueueing(senderEmail)
    if (!lastSendingId) {
      inactiveScheduleResponse = await createInactiveSchedule(idMessage, {
        IdMessage: parseInt(idMessage),
        SenderEmail: senderEmail,
        SenderName: senderName,
        ReplyToEmail: replyToEmail,
        IdDynamicSenderName: customNameValue || 0,
        IdDynamicSenderEmail: customEmailValue || 0,
        Source: 0
      })
    }
    const configurationResponse = await saveQueueingConfiguration(
      inactiveScheduleResponse ? inactiveScheduleResponse.Id : lastSendingId,
      includeGroups,
      excludeGroups,
      selectedFilters,
      typeAppliedFilters
    )

    await processQueueingConfiguration(configurationResponse.Id)

    set(senderInfoState, prev => ({
      ...prev,
      idAsyncQueueConfig: configurationResponse.Id,
      sendingOrScheduleId: inactiveScheduleResponse
        ? inactiveScheduleResponse.Id
        : lastSendingId
    }))
    set(pageState, prev => ({
      ...prev,
      wizardStep: 3
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'startQueueing',
      Message: "Errore durante l'accodamento dei messaggi"
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailSendingWizard.labelErrorMaster'
      }),
      TOAST_VARIANT_ERROR,
      'startQueueInfoFailed',
      false,
      true
    )
  }
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))
}

export const getSmartPlanningSuggestedDateCallback = ({
  set,
  snapshot
}) => async () => {
  try {
    const smartPlanningFeature =
      storeGet(STORE_KEY_FEATURES).indexOf('smartPlanning') >= 0
    const account = storeGet(STORE_KEY_ACCOUNT)
    const showSmartPlanning =
      smartPlanningFeature &&
      account.IdOffer !== 3 &&
      account.IdOffer !== 2 &&
      account.IdOffer !== 6 &&
      !account.IsOfferLight // NON E' UNA STARTER - FREQUENZA - SOLOSMS-LIGHT

    if (showSmartPlanning) {
      const { sendingOrScheduleId } = await snapshot.getPromise(senderInfoState)
      const { SuggestedDate, Detail } = await getSmartPlanningSuggestedDate(
        sendingOrScheduleId
      )

      set(smartPlanningState, prev => ({
        ...prev,
        smartPlanningDate: SuggestedDate,
        smartPlanningDateLoaded: true,
        smartPlanningError:
          Detail && Detail.Code === 422
            ? 'NoData'
            : Detail && Detail.Code === 404
            ? 'DataError'
            : undefined
      }))
    }
  } catch (error) {
    set(smartPlanningState, prev => ({
      ...prev,
      smartPlanningDate: '',
      smartPlanningDateLoaded: true,
      smartPlanningError: 'DataError'
    }))
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'getSmartPlanningSuggestedDateCallback'
    })
  }
}

export const initProgressCallback = ({ set, snapshot }) => async () => {
  set(progressState, prev => ({
    ...prev,
    loading: true,
    loaded: false,
    queueStatus: BEQUEUE_CONFIG_STATE_RUNNING
  }))
  const {
    Bandwidth: bandwidth,
    SendMethodType: sendMethodType,
    IsTrial: isTrial
  } = storeGet(STORE_KEY_ACCOUNT)

  const account = storeGet(STORE_KEY_ACCOUNT)
  const bandOrFreqOrLightConsole =
    account.IdOffer === 1 || account.IdOffer === 2 || account.IsOfferLight
  const abitudiniApertureEnabled = !bandOrFreqOrLightConsole

  try {
    if (abitudiniApertureEnabled) {
      const { Result } = await getBestPlanningDataAvailable()

      set(abitudiniApertureState, prev => ({
        ...prev,
        avaible: Result && !isTrial
      }))
    }

    set(progressState, prev => ({
      ...prev,
      bandwidth,
      sendMethodType
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'initProgress',
      Message: 'Errore in inizializzazione progresso da step wizard'
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(progressState, prev => ({ ...prev, loading: false, loaded: true }))
}

export const checkProgressCallback = ({ set, snapshot }) => async () => {
  const { idAsyncQueueConfig: idConf } = await snapshot.getPromise(
    senderInfoState
  )
  const { sendMethodType, bandwidth } = await snapshot.getPromise(progressState)
  let estimatedSendingTime = 0
  let dynamicContentsSize = 0

  try {
    const {
      State,
      Queued: queued,
      ToBeQueued: toBeQueued
    } = await getQueueConfiguration(idConf)
    let queuedPercentage = 0
    let queueStatus
    let variant = PROGRESSBAR_VARIANT_DEFAULT

    if (
      State === BEQUEUE_CONFIG_STATE_RUNNING ||
      State === BEQUEUE_CONFIG_STATE_UPDATING ||
      State === BEQUEUE_CONFIG_STATE_TOEXECUTE
    ) {
      queueStatus = BEQUEUE_CONFIG_STATE_RUNNING
      if (toBeQueued) {
        queuedPercentage = Math.floor((queued * 100) / toBeQueued)
      } else {
        queuedPercentage = 0
      }
      variant = PROGRESSBAR_VARIANT_DEFAULT
    }

    if (State === BEQUEUE_CONFIG_STATE_COMPLETED) {
      queueStatus = BEQUEUE_CONFIG_STATE_COMPLETED
      queuedPercentage = 100
      variant = PROGRESSBAR_VARIANT_SUCCESS
    }

    // QUEUING ERROR
    if (
      State === BEQUEUE_CONFIG_STATE_FAILED ||
      State === BEQUEUE_CONFIG_STATE_RETRIED ||
      State === BEQUEUE_CONFIG_STATE_CANCELLED ||
      State === BEQUEUE_CONFIG_STATE_DISCARDED
    ) {
      queueStatus = BEQUEUE_CONFIG_STATE_FAILED
      queuedPercentage = 100
      variant = PROGRESSBAR_VARIANT_ERROR
    }

    const { idMessage } = await snapshot.getPromise(pageState)
    const { size } = await snapshot.getPromise(
      messageDetailsState(parseInt(idMessage))
    )
    const idMessagesList = [parseInt(idMessage)]
    const { Items } = await getDynamicContents(idMessagesList)

    const messagesDynamicContents = Items.filter(
      message => message.IdMessage === idMessage
    )

    messagesDynamicContents.forEach(message => {
      message.Contents.forEach(content => {
        dynamicContentsSize += content.Size
      })
    })

    if (sendMethodType === SENDING_METHOD_TYPE_FREQUENCY) {
      estimatedSendingTime = Math.round((toBeQueued / bandwidth) * 60)
    } else {
      estimatedSendingTime =
        ((size + dynamicContentsSize) * toBeQueued) / (1024 * bandwidth)
    }

    set(progressState, prev => ({
      ...prev,
      queueStatus,
      queued,
      toBeQueued,
      queuedPercentage,
      variant,
      estimatedSendingTime
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'checkProgress',
      Message: 'Errore in progresso accodamento da step wizard'
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const deleteRecipientsCallback = ({
  set,
  snapshot,
  reset
}) => async () => {
  const { idAsyncQueueConfig } = await snapshot.getPromise(senderInfoState)
  let res = false
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))
  try {
    reset(modalDeleteState)
    res = await deleteRecipients(idAsyncQueueConfig)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'deleteRecipientsCallback',
      Message: 'Errore in deleteRecipientsCallback'
    })
    res = false
  }

  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))

  if (!res) {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailSendingWizard.labelErrorMaster'
      }),
      TOAST_VARIANT_ERROR,
      'LoadEmailSendingWizarderrlabelErrorMaster'
    )
  }

  return res
}

export const retryCallback = ({ set, snapshot, reset }) => async () => {
  const { idAsyncQueueConfig } = await snapshot.getPromise(senderInfoState)
  let toastError = false
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))
  try {
    const resId = await retryCheckQueue(idAsyncQueueConfig)
    await processQueueingConfiguration(resId)
    set(senderInfoState, prev => ({
      ...prev,
      idAsyncQueueConfig: resId
    }))
    if (resId <= 0) {
      toastError = true
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'retryCallback',
      Message: 'Errore in retry'
    })
    toastError = true
  }

  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))

  if (toastError) {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailSendingWizard.labelErrorMaster'
      }),
      TOAST_VARIANT_ERROR,
      'LoadEmailSendingWizarderrlabelErrorMaster'
    )
  }
}

export const scheduleNowCallback = ({ set }) => async (
  idSending,
  scheduleType
) => {
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))
  let res = true
  try {
    logAppInfo({
      Component: 'EmailSendingWizard',
      Method: 'scheduleNowCallback',
      Message: 'Inizio imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending, scheduleType })
    })

    await scheduleNow(idSending, scheduleType)

    logAppInfo({
      Component: 'EmailSendingWizard',
      Method: 'scheduleNowCallback',
      Message: 'Fine imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending, scheduleType })
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingWizard',
      Method: 'scheduleNowCallback',
      Message: 'Errore imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending, scheduleType })
    })

    res = false
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))
  return res
}

export const evaluateSendingBestPlanningTimeCallback = ({
  set
}) => async () => {
  set(abitudiniApertureState, prev => ({
    ...prev,
    loading: true
  }))
  try {
    const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

    var date = moment()
      .subtract(1, 'years')
      .toDate()
      .toISOString()

    const data = {
      DateFrom: date,
      Timezone: TimeZoneCode,
      StatisticTypeList: ['Opens']
    }
    const { SendingBestPlanningTime } = await evaluateSendingBestPlanningTime(
      data
    )

    const bestValue =
      getDayOfWeek(SendingBestPlanningTime.DayOfWeek) +
      ', ' +
      getHours(SendingBestPlanningTime.Hour) +
      ' - ' +
      getHours(SendingBestPlanningTime.Hour + 1)

    set(abitudiniApertureState, prev => ({
      ...prev,
      loading: false,
      bestValue: bestValue
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingWizard',
      Method: 'evaluateSendingBestPlanningTimeCallback',
      Message: 'Errore evaluateSendingBestPlanningTimeCallback',
      Data: JSON.stringify({ error })
    })

    set(abitudiniApertureState, prev => ({
      ...prev,
      loading: false
    }))

    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR
    )
  }
}

const getHours = val => {
  const hour = val < 9 ? '0' + val : val
  return hour + ':00'
}

const getDayOfWeek = day => {
  switch (day) {
    case 0:
      return getIntl().formatMessage({ id: 'Load.MailupCommon.Sunday' })
    case 1:
      return getIntl().formatMessage({ id: 'Load.MailupCommon.Monday' })
    case 2:
      return getIntl().formatMessage({ id: 'Load.MailupCommon.Tuesday' })
    case 3:
      return getIntl().formatMessage({ id: 'Load.MailupCommon.Wednesday' })
    case 4:
      return getIntl().formatMessage({ id: 'Load.MailupCommon.Thursday' })
    case 5:
      return getIntl().formatMessage({ id: 'Load.MailupCommon.Friday' })
    case 6:
      return getIntl().formatMessage({ id: 'Load.MailupCommon.Saturday' })
  }
}

export const sendingScheduleSetScheduleCallback = ({ set, snapshot }) => async (
  dateStart,
  timeZone,
  mode
) => {
  const { sendingOrScheduleId } = await snapshot.getPromise(senderInfoState)
  let res = true

  try {
    logAppInfo({
      Component: 'EmailSendingWizard',
      Method: 'emailSendingWizardSetImmediateCallback',
      Message: 'Inizio imposta schedulazione invio',
      Data: JSON.stringify({ sendingOrScheduleId, dateStart, timeZone })
    })
    const planningType = mode ? (mode === MODE_SMART ? 1 : 0) : 0
    await setSendingScheduled(
      sendingOrScheduleId,
      dateStart,
      timeZone,
      planningType
    )
    if (mode === MODE_SMART) {
      pendoTrack('Smart Scheduling - Email Sending Wizard', {})
    }

    logAppInfo({
      Component: 'EmailSendingWizard',
      Method: 'emailSendingWizardSetScheduleCallback',
      Message: 'Fine imposta schedulazione invio',
      Data: JSON.stringify({ sendingOrScheduleId, dateStart, timeZone })
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingWizard',
      Method: 'emailSendingWizardSetScheduleCallback',
      Message: 'Errore imposta schedulazione invio',
      Data: JSON.stringify({ sendingOrScheduleId, dateStart })
    })

    res = false
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(modalSchedulingState, prev => ({
    ...prev,
    show: false
  }))

  return res
}

export const sendingScheduleSetImmediateCallback = ({
  set,
  snapshot
}) => async () => {
  const { sendingOrScheduleId } = await snapshot.getPromise(senderInfoState)
  let res = true

  try {
    logAppInfo({
      Component: 'EmailSendingWizard',
      Method: 'emailSendingWizardSetImmediateCallback',
      Message: 'Inizio imposta invio sequenziale',
      Data: JSON.stringify({ sendingOrScheduleId })
    })

    await setSendingImmediate(sendingOrScheduleId)

    logAppInfo({
      Component: 'EmailSendingWizard',
      Method: 'emailSendingWizardSetImmediateCallback',
      Message: 'Fine imposta invio sequenziale',
      Data: JSON.stringify({ sendingOrScheduleId })
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingWizard',
      Method: 'emailSendingWizardSetImmediateCallback',
      Message: 'Errore imposta invio sequenziale',
      Data: JSON.stringify({ sendingOrScheduleId })
    })

    res = false
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(modalSchedulingState, prev => ({
    ...prev,
    show: false
  }))

  return res
}

export const errorCallback = ({ set }) => async error => {
  logAppError({
    appError: error,
    Component: 'EmailSendingWizard',
    Method: 'errorCallback'
  })

  set(pageState, prev => ({
    ...prev,
    error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
    severity: 'danger'
  }))
}
